import React from 'react';

import useWireframeLoaded from '@/core/features/wireframe/use-wireframe-loaded';

export default function useAppBridgeInit(): void {
    // Add global App Bridge callback methods
    React.useEffect(() => {
        if (window?.C24App) {
            // eslint-disable-next-line fp/no-mutation
            window.C24App.setHeaderScrollingDisabledCompletion = () => {};
        }
    }, []);

    const onWireframeLoaded = React.useCallback(() => {
        /**
         * Always show tap bar on android
         * https://confluence.check24.de/display/HNAM/Main+Web+API #C24App.setHeaderScrollingDisabled()
         */
        if (window?.C24App?.isAndroidBridgeAvailable()) {
            window.C24App.setHeaderScrollingDisabled();
        }
    }, []);

    useWireframeLoaded(onWireframeLoaded, [onWireframeLoaded]);
}
